import { type BaseUrl } from '~/types/baseUrl';
import { getBaseUrl } from '~/utils/getBaseUrl';

const organisationsBaseUrl: BaseUrl = {
  production: 'https://platform.versori.com/api/organisations/v1',
  staging: 'https://platform-staging.versori.com/api/organisations/v1',
  development: 'http://localhost:8081/v1',
};

export type AuthMethods = {
  methods: string[];
  ssoProvider?: string;
  ssoEnforced: boolean;
};

/**
 * resolveAuthMethods asks organisations-api which login methods apply to an email's domain. It is used after login
 * to enforce SSO for domains configured as `required`. Returns null on any failure so callers fail open (the user
 * is not locked out by a transient backend error). The endpoint is unauthenticated.
 */
export async function resolveAuthMethods(email: string): Promise<AuthMethods | null> {
  try {
    const response = await fetch(`${getBaseUrl(organisationsBaseUrl)}/auth/methods`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(import.meta.env.VITE_API_JWT && {
          'X-Versori-Internal-Token': import.meta.env.VITE_API_JWT,
        }),
      },
      body: JSON.stringify({ email }),
      mode: 'cors',
      credentials: 'include',
    });

    if (!response.ok) {
      return null;
    }

    return (await response.json()) as AuthMethods;
  } catch {
    return null;
  }
}
